import MuiTypography from '@mui/material/Typography';
import { Stack, Box } from '@mui/system';
import dayjs from 'dayjs';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import _ from 'lodash';
import { Status } from '../../booking/conf/Data.conf';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import { API } from '../../operations/api';
import provisions from '../index';
import RowItem from '../../../components/listItem/table/RowItem.component';
import Typography from '../../../components/common/Typography.component';
import Modal from '../../../components/common/Modal.component';
import itemsProvisions from '../../listItemsProvisions';
import RectangleChip from '../../../components/common/RectangleChip.component';
import {
  StatusBilling,
  StatusOperationBookingType,
} from '../../operations/conf/Data.conf';
import TextField from '../../../components/form/components/TextField.component';
import { Chip, Grid, Checkbox, Tooltip } from '@mui/material';
import { ListAllItemsConf } from '../../listItemsProvisions/conf/List.conf';
import SimpleTable from '../../../components/simpleTable/SimpleTable.component';
import SelectCustom from '../../../components/form/components/SelectCustom.component';
import LinkProductsList from '../../../components/item/button/ButtonProductsList.component';
import { TAB_ORDERED } from '../../listItem/conf/Data.conf';
import TemplateDelete from '../../../pages/templates/Delete.template';
import DuplicateTemplate from '../../../pages/duplicate/Duplicate.template';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: {
      by: 'requested_date',
      direction: 'asc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'checkbox_select',
      key: 'checkbox_select',
      sort_key: '',
      sortable: false,
      label: '',
      checkbox: true,
      width: 40,
      selectable: true,
    },
    {
      id: 'attributes.duplicate',
      key: 'duplicate',
      label: '',
      width: 1,
      checkbox: true,
    },
    {
      id: 'attributes.id_yacht.data',
      key: 'yacht_name',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'Yacht Name',
      width: '200px',
    },
    {
      id: 'attributes.status_operation_booking_id',
      key: 'status_operation_booking_id',
      sort_key: 'status_operation_booking',
      sortable: true,
      label: 'Operational Status',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.id_service.data.attributes.service',
      key: 'service',
      sort_key: 'id_service.service',
      sortable: true,
      label: 'Service',
      width: '120px',
    },
    {
      id: 'attributes',
      key: 'products',
      sortable: false,
      label: 'Products',
      width: '240px',
    },
    {
      id: 'attributes.id_delivery_note.data.attributes.delivery_note_number',
      key: 'id_delivery_note',
      sort_key: 'id_delivery_note.delivery_note_number',
      sortable: true,
      label: 'N. Order',
      width: 170,
    },
    {
      id: 'attributes.requested_date',
      key: 'requested_date',
      sort_key: 'requested_date',
      sortable: true,
      label: 'Date',
      width: '160px',
    },
    {
      id: 'attributes.requested_hour',
      key: 'requested_hour',
      sort_key: 'requested_hour',
      sortable: true,
      label: 'Time',
      width: '120px',
    },
    {
      id: 'attributes.id_marina.data.attributes.marina',
      key: 'id_marina',
      sort_key: 'id_marina.marina',
      sortable: true,
      label: 'Location',
      width: 160,
    },
    {
      id: 'attributes.OC_fees_id',
      key: 'OC_fees_id',
      sort_key: 'OC_fees',
      sortable: true,
      label: 'Notes',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.OC_BC_number_id',
      key: 'OC_BC_number_id',
      sort_key: 'OC_BC_number',
      sortable: true,
      label: 'Sales Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.OF_BF_number_id',
      key: 'OF_BF_number_id',
      sort_key: 'OF_BF_number',
      sortable: true,
      label: 'Purchase Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.account_type',
      key: 'account_type',
      sort_key: 'account_type',
      sortable: true,
      label: 'CH/BOAT',
      width: '100px',
    },
    {
      id: 'attributes.status_billing_id',
      key: 'status_billing_id',
      sort_key: 'status_billing',
      sortable: true,
      label: 'Billing Status',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.billing_notes_id',
      key: 'billing_notes_id',
      sort_key: 'billing_notes',
      sortable: true,
      label: 'Billing Notes',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes',
      key: 'delete',
      sortable: false,
      label: '',
      width: '0px',
      checkbox: true,
    },
  ],
  render: {
    formatHead: (key, value, { isChecked, indeterminate }) => {
      switch (key) {
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              indeterminate={indeterminate}
            />
          );
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick, isChecked) => {
      switch (key) {
        case 'status_operation_booking_id':
          const color = _.find(
            Status,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_operation_booking?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...provisions,
                query: {
                  ...provisions.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_operation_booking: value?.status_operation_booking,
              }}
              name={'status_operation_booking'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_operation_booking'
                    name='status_operation_booking'
                    label='Operational Status'
                    options={StatusOperationBookingType}
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_operation_booking ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_operation_booking}
                    backgroundColor={color?.hex}
                    color='#fff'
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );
        case 'yacht_name': {
          const attendance =
            value?.attributes?.id_attendance?.data?.[0]?.attributes ||
            value?.attributes?.id_attendance?.data?.attributes ||
            value?.attributes?.id_yacht?.data?.attributes?.id_attendance?.data?.[0]?.attributes;
          const provenence =
            attendance?.id_provenence_list?.data?.attributes?.provenence?.data
              ?.attributes?.provenence ||
            value?.attributes?.provenence;
          const mexalCode = attendance?.mexal_code || '-';
          const mexalResearchName = attendance?.mexal_research_name || '-';
          const mexalTooltip = [mexalCode, mexalResearchName]
            .filter((item) => item && item !== '-')
            .join(' - ');

          return (
            <Tooltip title={mexalTooltip || ''}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                spacing={1}
              >
                <Stack direction={'column'} spacing={0.5}>
                  <MuiTypography
                    variant='body1'
                    sx={{ fontWeight: 'bold' }}
                    onClick={onClick}
                  >
                    {value?.attributes?.yacht_name || '-'}
                  </MuiTypography>
                  {provenence && (
                    <MuiTypography
                      variant='caption'
                      color='text.secondary'
                      onClick={onClick}
                    >
                      {provenence}
                    </MuiTypography>
                  )}
                  <Chip
                    label={`#${value?.id || '-'}`}
                    size="small"
                    sx={{ width: 'fit-content', alignSelf: 'flex-start' }}
                  />
                </Stack>
              </Stack>
            </Tooltip>
          );
        }
        case 'date_out':
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CalendarIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value || '-'}
              </MuiTypography>
            </Stack>
          );
        case 'requested_date': {
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CalendarIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value ? dayjs(value).format('DD-MM-YYYY') : '-'}
              </MuiTypography>
            </Stack>
          );
        }

        case 'requested_hour': {
          return value ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <AccessTimeIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {dayjs(value, 'HH:mm:ss').format('HH:mm')}
              </MuiTypography>
            </Stack>
          ) : (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              -
            </MuiTypography>
          );
        }
        case 'name': {
          return value ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <PersonIcon color='action' fontSize='small' />
              <MuiTypography
                sx={{ height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {`${value?.name} ${value?.surname}`}
              </MuiTypography>
            </Stack>
          ) : (
            '-'
          );
        }
        case 'OC_BC_number_id':
          return (
            <TableCellEdit
              module={{
                ...provisions,
                query: {
                  ...provisions.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_BC_number: value?.OC_BC_number }}
              value={value}
              name={'OC_BC_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_BC_number'
                    name='OC_BC_number'
                    label='Sales Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_BC_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );

        case 'OF_BF_number_id':
          return (
            <TableCellEdit
              module={{
                ...provisions,
                query: {
                  ...provisions.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OF_BF_number: value?.OF_BF_number }}
              value={value}
              name={'OF_BF_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OF_BF_number'
                    name='OF_BF_number'
                    label='Purchase Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OF_BF_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'OC_fees_id':
          return (
            <TableCellEdit
              module={{
                ...provisions,
                query: {
                  ...provisions.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_fees: value?.OC_fees }}
              value={value}
              name={'OC_fees'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_fees'
                    name='OC_fees'
                    label='Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_fees || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'billing_notes_id':
          return (
            <TableCellEdit
              module={{
                ...provisions,
                query: {
                  ...provisions.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ billing_notes: value?.billing_notes }}
              value={value}
              name={'billing_notes'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='billing_notes'
                    name='billing_notes'
                    label='Billing Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.billing_notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'status_billing_id':
          const colorBilling = _.find(
            StatusBilling,
            (item) =>
              item.label.toUpperCase() === value?.status_billing?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...provisions,
                query: {
                  ...provisions.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_billing: value?.status_billing,
              }}
              name={'status_billing'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_billing'
                    name='status_billing'
                    label='Status Billing'
                    options={StatusBilling}
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_billing ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_billing}
                    backgroundColor={colorBilling?.hex}
                    color='#fff'
                    width={150}
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );
        case 'service':
          return value ? (
            <RectangleChip
              value={value}
              width={'auto'}
              backgroundColor={'#009ab6'}
              color='#fff'
            />
          ) : (
            '-'
          );

        case 'products':
          const sortProducts = _.orderBy(
            value?.id_list?.data?.attributes?.id_list_items?.data || [],
            ['attributes.id_logbook.data.id'],
            ['asc']
          );
          const chunkSize = 3;
          const liteProducts = sortProducts.slice(0, chunkSize);
          const remainingCount = Math.max(sortProducts.length - liteProducts.length, 0);

          return !_.isEmpty(sortProducts) ? (
            <Stack spacing={1.2} sx={{ py: 0.5 }}>
              <Stack
                direction='row'
                spacing={0.75}
                alignItems='center'
                justifyContent='space-between'
                sx={{ width: '100%', maxWidth: '100%' }}
              >
                <Stack direction='row' spacing={0.75} alignItems='center'>
                  <Inventory2OutlinedIcon fontSize='small' color='action' />
                  <MuiTypography
                    variant='caption'
                    sx={{ fontWeight: 700, color: 'text.secondary' }}
                  >
                    {sortProducts.length} products
                  </MuiTypography>
                </Stack>

                {value?.id_list_id?.id_list && (
                  <Box
                    sx={{ ml: 'auto' }}
                    onClick={() => {
                      localStorage.setItem('tab', TAB_ORDERED);
                      localStorage.setItem('idLogbook', value?.id_logbook);
                    }}
                  >
                    <Tooltip title='Open Items List'>
                      <span>
                        <LinkProductsList
                          label={
                            <Box
                              sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: 0,
                              }}
                            >
                              <OpenInNewIcon sx={{ fontSize: 15 }} />
                            </Box>
                          }
                          to={`${value?.id_list_id?.id}/list/${value?.id_list_id?.id_list}`}
                          state={{
                            id_operation: `${value?.id_list_id?.id}`,
                            yachtName: value?.id_yacht?.data?.attributes?.yacht_name,
                            orderType: value?.id_service?.data?.attributes?.service,
                          }}
                          sx={{
                            minWidth: 26,
                            width: 26,
                            height: 26,
                            borderRadius: '50%',
                            p: 0,
                            backgroundColor: '#009ab6',
                          }}
                          variant='contained'
                          page='PROVISIONS'
                        />
                      </span>
                    </Tooltip>
                  </Box>
                )}
              </Stack>

              {liteProducts.map((item) => (
                <Box
                  key={item?.id || item?.attributes?.id_item?.data?.id}
                  sx={{
                    pl: 0.75,
                    borderLeft: '2px solid',
                    borderColor: 'divider',
                  }}
                >
                  <RowItem data={item} module={itemsProvisions} />
                </Box>
              ))}

              {remainingCount > 0 && (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                  <Modal
                    label={
                      <Stack direction='row' spacing={0.5} alignItems='center'>
                        <AddCircleOutlineIcon sx={{ fontSize: 16, color: 'text.secondary', textDecoration: 'underline' }} />
                        <MuiTypography
                          variant='caption'
                          color='text.secondary'
                          sx={{
                            textDecoration: 'underline',
                            cursor: 'pointer'
                          }}
                        >
                          {remainingCount} more products
                        </MuiTypography>
                      </Stack>
                    }
                    sx={{ color: 'text.primary' }}
                    width='80%'
                  >
                    <Stack spacing={2}>
                      <Typography
                        variant='h4'
                        sx={{
                          fontWeight: 'bold',
                          alignItems: 'center',
                          display: 'flex',
                        }}
                      >
                        Items List
                      </Typography>
                      <SimpleTable
                        minWidth={900}
                        data={sortProducts}
                        module={{ list: { conf: ListAllItemsConf } }}
                      />
                    </Stack>
                  </Modal>
                </Box>
              )}
            </Stack>
          ) : (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              -
            </MuiTypography>
          );

        case 'id_delivery_note':
          return value ? <Chip label={`N° ${value}`} /> : '-';
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              disabled={onClick ? false : true}
            />
          );
        case 'delete':
          return (
            <TemplateDelete module={provisions} idDelete={value?.id} isIcon>
              <Box mt={1}>
                The list of items and linked logbooks will be deleted.
              </Box>
            </TemplateDelete>
          );
        case 'duplicate':
          return <DuplicateTemplate module={provisions} data={value} isIcon />;
        default:
          return (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};
